__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "container";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.11.4", () => (Promise.all([__webpack_require__.e(4300), __webpack_require__.e(4914), __webpack_require__.e(3341)]).then(() => (() => (__webpack_require__(5722))))));
			register("@emotion/styled", "11.11.5", () => (Promise.all([__webpack_require__.e(4914), __webpack_require__.e(1678), __webpack_require__.e(3860)]).then(() => (() => (__webpack_require__(1479))))));
			register("@hookform/resolvers", "3.6.0", () => (Promise.all([__webpack_require__.e(7598), __webpack_require__.e(6912)]).then(() => (() => (__webpack_require__(6912))))));
			register("@mui/material", "5.15.20", () => (Promise.all([__webpack_require__.e(4300), __webpack_require__.e(564), __webpack_require__.e(561), __webpack_require__.e(638), __webpack_require__.e(2957), __webpack_require__.e(4914), __webpack_require__.e(1678), __webpack_require__.e(4118), __webpack_require__.e(6672), __webpack_require__.e(4848)]).then(() => (() => (__webpack_require__(2957))))));
			register("@tanstack/react-query", "5.45.1", () => (Promise.all([__webpack_require__.e(5084), __webpack_require__.e(4914), __webpack_require__.e(2467)]).then(() => (() => (__webpack_require__(5084))))));
			register("axios", "1.7.2", () => (__webpack_require__.e(4447).then(() => (() => (__webpack_require__(4447))))));
			register("dexie", "3.2.7", () => (__webpack_require__.e(5830).then(() => (() => (__webpack_require__(5830))))));
			register("i18next-resources-to-backend", "1.2.1", () => (__webpack_require__.e(1235).then(() => (() => (__webpack_require__(1235))))));
			register("i18next", "23.11.5", () => (__webpack_require__.e(2635).then(() => (() => (__webpack_require__(2635))))));
			register("localforage", "1.10.0", () => (__webpack_require__.e(3790).then(() => (() => (__webpack_require__(3790))))));
			register("luxon", "3.4.4", () => (__webpack_require__.e(6285).then(() => (() => (__webpack_require__(6285))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(961))))));
			register("react-hook-form", "7.52.0", () => (Promise.all([__webpack_require__.e(9785), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(9785))))));
			register("react-i18next", "13.5.0", () => (Promise.all([__webpack_require__.e(2389), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(2389))))));
			register("react", "18.3.1", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(6540))))));
			register("zod", "3.23.8", () => (__webpack_require__.e(4476).then(() => (() => (__webpack_require__(4476))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};